<!-- prettier-ignore -->
      
    <div class="form-tech-wrapper">
    
        <h1>{{'Información para la ruta' | translate}}</h1>
        <div class="form-group-tech" >
            <label class="labels">
                <span>{{ 'Nombre de la ruta' | translate }}</span> *
            </label>
            @for(lang of tools.languages(); track lang) {
                <div class="input-wrapper" [ngClass]="{'hidden': translate.currentLang != lang.code}">
                    <input #input autocomplete="off" (focusin)="focusin($event)" type="text" (keyup)="insertText(input.value, lang.code)" [value]="item()?.name?.[translate.currentLang] || ''"/>
                </div>
            }

        </div>
    
        <div class="form-group-cropper" >

            <div class="form-card-preview-wrapper">
                <div class="route-card-tech">
                    <cicerone-route-card [item]="item()" [isSaveRoute]="true"></cicerone-route-card>
                </div>
                <div class="file-upload">
                    <input type="file" id="fileInput" class="file-input" (change)="fileChangeEvent($event)">
                    <label for="fileInput" class="file-label">{{'Cambiar imagen' | translate}}</label>
                </div>
            </div>

            <div class="cropper-container">
                @if(imageChangedEvent){
                    <image-cropper
                        [imageChangedEvent]="imageChangedEvent"
                        [maintainAspectRatio]="true"
                        [containWithinAspectRatio]="true"
                        [aspectRatio]="262/153"
                        format="webp"
                        [output]="'base64'"
                        (imageCropped)="imageCropped($event)"
                        (imageLoaded)="imageLoaded($event)"
                        (cropperReady)="cropperReady()"
                        (loadImageFailed)="loadImageFailed()"
                        [resizeToWidth]="524"
                    ></image-cropper>
                }
                @else {
                    <img draggable="false" [src]="item().image" (error)="tools.onImageError($event)" style="width: 100%; height: 100%; object-fit: cover;">
                }

            </div>
        </div>
    
    
        <div class="send-buttons-container">
            <button (click)="goBack()" type="button" class="back-button">{{'Volver' | translate}}</button>        
            <button (click)="saveRoute()" class="send-button" [ngClass]="{'loader' : savingRoute()}" [disabled]="savingRoute()">
                @if(savingRoute()){
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" style="height: 40px; width: 40px; position: absolute;">
                        <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
                            <stop offset="0" stop-color="#FFFFFF"></stop>
                            <stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop>
                            <stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop>
                            <stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop>
                            <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop>
                        </radialGradient>
                        <circle transform-origin="center" fill="none" stroke="url(#a12)" stroke-width="40" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
                            <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
                        </circle>
                        <circle transform-origin="center" fill="none" opacity=".2" stroke="#FFFFFF" stroke-width="40" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
                    </svg>
                }
                @else {
                    {{ 'Guardar' | translate }}            
                }
            </button>

        </div>
    
        <!-- <img style="margin-top: 25px;" [src]="croppedImage" /> -->
    
        
    </div>

